import { useContext, useState } from 'react';
import {
    VehicleDataSpecRequest,
    VehicleDataTrimsAndSpecApiResponse,
} from '../../../services/vehicle-data-service/vehicle-data-service.types';
import { vehicleDataService } from '../../../services/vehicle-data-service/vehicle-data-service';
import ServerContext from '../../../contexts/serverContext';

interface HookState {
    error: null | boolean;
    loading: boolean;
    data: null | VehicleDataTrimsAndSpecApiResponse;
}

type FetchDataRequest = Omit<
    VehicleDataSpecRequest,
    'countryCode' | 'language'
>;
const initialState: HookState = {
    error: null,
    loading: false,
    data: null,
};

export const stringifyVehicleTrim = (trimName: string) => {
    return encodeURI(trimName.toLowerCase());
};

export const useTrimsAndSpecs = (): [
    (params: FetchDataRequest) => void,
    HookState
] => {
    const { current3LetterCountryCode, currentLanguageRegionCode } = useContext(
        ServerContext
    );

    const [state, setState] = useState<HookState>(initialState);

    const fetchData = async (params: FetchDataRequest) => {
        setState(prev => ({ ...prev, loading: true }));

        const fullParams: VehicleDataSpecRequest = {
            countryCode: current3LetterCountryCode.toUpperCase(),
            language: currentLanguageRegionCode.replace('-', '_'),
            ...params,
        };

        vehicleDataService.getVehicleTrimsAndSpecs(fullParams).then(res => {
            if (res) {
                let transformedSpec = res?.vehicleSpec;
                if (res?.vehicleSpec) {
                    transformedSpec = Object.keys(res?.vehicleSpec).reduce(
                        (obj, trimName) => {
                            return {
                                ...obj,
                                [stringifyVehicleTrim(trimName)]: res
                                    .vehicleSpec[trimName],
                            };
                        },
                        {}
                    );
                }

                setState(prev => ({
                    ...prev,
                    data: {
                        trims: res!.trims,
                        vehicleSpec: transformedSpec,
                    },
                    loading: false,
                }));
            } else
                setState(prev => ({
                    ...prev,
                    loading: false,
                }));
        });
    };
    return [fetchData, { ...state }];
};
